import { connect } from 'datocms-plugin-sdk';
import { render } from './utils/render';
import ConfigScreen from './entrypoints/ConfigScreen';
import FieldExtension from './entrypoints/FieldExtension';
import 'datocms-react-ui/styles.css';
import './style.css';

connect({
  renderConfigScreen(ctx) {
    return render(<ConfigScreen ctx={ctx} />);
  },
  manualFieldExtensions(ctx) {
    return [
      {
        id: 'bms-trip-input',
        // Mirror the installation's display name so the field-editor tile
        // always matches the Configuration > Plugins list ([Prev]/[Prod]).
        name: ctx.plugin.attributes.name || 'BMS Trip',
        type: 'editor',
        fieldTypes: ['json'],
      },
    ];
  },
  renderFieldExtension(id, ctx) {
    render(<FieldExtension ctx={ctx} />);
  },
});
